module.exports = __webpack_public_path__ + "static/img/7.afcdb57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/7.png
// module id = EiHd
// module chunks = 0